module.exports = __webpack_public_path__ + "img/ime_icon.3846d7da.svg";